module.exports = function() {
  return new Worker(__webpack_public_path__ + "ccd37fb0cf3f14dd6b4e.worker.js");
};